import Vue from 'vue'

export const isThirdPartyEmbed = () => {
  const thirdPartyLinkEmbed = sessionStorage.getItem('third_party_link_embed')
  // 任意第三方嵌入标识均走H5授权，保留市妇幼疫苗预约值判断兜底
  return !!thirdPartyLinkEmbed || thirdPartyLinkEmbed === 'sfy_vaccine_appointment'
}

export const thirdPartyAuthRedirect = () => {
  const redirectUri = encodeURIComponent(
    `${document.location.protocol}//vote.ynhdkc.com/apis/v1/user/session/users/wechat_callback?redirect=${encodeURIComponent(
      window.location.href
    )}&channel=2`
  )
  location.assign(
    `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx324860af71b94a93&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
  )
}

export const reauth = (tips = '') => {
  return new Promise((resolve) => {
    // 第三方嵌入H5，走h5授权
    if (isThirdPartyEmbed()) {
      if (localStorage.getItem('authtoken')) {
        resolve(true)
        return
      }
      thirdPartyAuthRedirect()
      resolve(false)
      return
    }
    window.wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        // 在小程序
        const data = localStorage.getItem('authtoken')
        if (data) {
          resolve(true)
          return
        }
        Vue.prototype.$dialog.confirm({
          title: '温馨提示',
          message: '您尚未登录，为保证您能使用完整功能，是否先去登录？',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          // 点击确定
          window.wx.miniProgram.redirectTo({
            url: `/pages/login/index`
          })
        }).catch(() => {
          // 点击取消
          tips && Vue.prototype.$toast(tips)
          resolve(false)
        })
        return
      } else {
        // 在公众号， 目前只兼容了小程序，这里统一放过
        resolve(true)
      }
    })
  })
}
